import { defineRouter } from '#q-app'
import { PersonRole } from '@/enums/PersonRole'

import { useAuthStore } from '@/stores/auth_store'
import { Dialog } from 'quasar'
import type {
  RouteLocationAsPathGeneric,
  RouteLocationAsRelativeGeneric,
  RouteLocationNormalized,
  RouteLocationNormalizedGeneric,
  RouteLocationRaw,
  RouteParamsGeneric,
} from 'vue-router'
import {
  createMemoryHistory,
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from 'vue-router'
import { dirtyForms } from '../services/FormService'
import routes from './routes'

const createHistory = import.meta.env.CLI_SERVER
  ? createMemoryHistory
  : import.meta.env.QUASAR_VUE_ROUTER_MODE === 'history'
    ? createWebHistory
    : createWebHashHistory
export const Router = createRouter({
  scrollBehavior: () => ({ left: 0, top: 0 }),
  routes,

  // Leave this as is and make changes in quasar.conf.js instead!
  // quasar.conf.js -> build -> vueRouterMode
  // quasar.conf.js -> build -> publicPath
  history: createHistory(import.meta.env.QUASAR_VUE_ROUTER_BASE),
})
export default defineRouter(function ({ store }) {
  const $auth = useAuthStore(store)

  const setIntended = (location: RouteLocationRaw, to: RouteLocationNormalizedGeneric) => {
    if (
      (typeof location !== 'string' && location.query?._int) ||
      to.path === '/' ||
      to.path.startsWith('/auth/')
    ) {
      return location
    }
    const newLocation: RouteLocationAsRelativeGeneric | RouteLocationAsPathGeneric =
      typeof location === 'string' ? { path: location } : location
    newLocation.query ??= {}
    newLocation.query._int = btoa(to.fullPath)
    return newLocation
  }

  const releaseIntended = (location: RouteLocationNormalized) => {
    if (location.query?._int) {
      return atob(<string>location.query._int)
    } else {
      return '/'
    }
  }

  /*Router.forcePush = async (
    to: RouteLocationRaw,
  ): Promise<NavigationFailure | void | undefined> => {
    await Router.push('/_')
    await Router.replace(to)
  }*/

  Router.beforeEach(async (to, from) => {
    if (to.path === '/s') {
      window.location.href = '/'
      return
    }
    to.params = { ...to.params, ...to.query } as RouteParamsGeneric

    if (!$auth.isLoggedIn) {
      if (!['auth.login', 'auth.register'].includes(to.name as string)) {
        return setIntended('/auth/login', to)
      }
    } else if (
      !$auth.person?.original_person &&
      !$auth.hasRole(PersonRole.Child) &&
      !($auth.person?.roles.length === 1 && $auth.hasRole(PersonRole.FamilyAssistant)) &&
      (!$auth.person?.email?.confirmed || !$auth.person.phone?.confirmed || !$auth.person.name)
    ) {
      if (!$auth.person?.phone?.confirmed) {
        if (to.path !== '/auth/phone') {
          if (!to.path.startsWith('/auth/')) {
            return setIntended('/auth/phone', to)
          } else {
            return '/auth/phone'
          }
        }
      } else if (!$auth.person?.email?.confirmed) {
        if (to.path !== '/auth/email') {
          if (!to.path.startsWith('/auth/')) {
            return setIntended('/auth/email', to)
          } else {
            return '/auth/email'
          }
        }
      }
    } else if (to.path.startsWith('/auth/')) {
      //next(releaseIntended(to))
      return releaseIntended(to)
    } else if (to.path.startsWith('/m') && !$auth.person?.employee?.permissions.length) {
      // next('/')
      return '/'
    } else if (
      $auth.person?.roles?.length === 1 &&
      $auth.hasRole(PersonRole.FamilyAssistant) &&
      to.path !== '/aqr'
    ) {
      return '/aqr'
    } else {
      if (dirtyForms.length) {
        return await new Promise<RouteLocationNormalizedGeneric>((resolve) => {
          Dialog.create({
            message: 'Все несохранённые изменения будут потеряны. Продолжить?',
            cancel: true,
            color: 'warning',
            persistent: true,
          })
            .onOk(() => {
              dirtyForms.length = 0
              resolve(to)
            })
            .onCancel(() => {
              resolve(from)
            })
        })
      }
    }
  })
  return Router
})
